import script from "./KCategoryPosCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCategoryPosCard.vue?vue&type=script&setup=true&lang=ts"

import "./KCategoryPosCard.vue?vue&type=style&index=0&id=fa048790&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa048790"]])

export default __exports__